import { defineStore } from 'pinia';

import { WorkflowStatus } from '@/workflow-status';
import { getSearchPills, getSearchQueryString, getSearchQueryStringWithoutStatus } from '@/store/search-utils';

export const useMerckIndexSearchStore = defineStore('merckIndexSearch', {

  // STATE
  state: () => ({
    UserList: [],
    SearchParams: {
      // CONTAINER
      'containerName':         { 'label': 'Container name', 'value': '' },
      
      // METADATA
      'status':                { 'value': WorkflowStatus.REVIEW },
      'createdBy':             { 'label': 'Created by', 'value': '' },
      'lastModifiedBy':        { 'label': 'Last modified by', 'value': '' },
      'datePublishedFrom':     { 'label': 'Published after', 'value': '' },
      'datePublishedTo':       { 'label': 'Published before', 'value': '' },
      'dateCreatedFrom':       { 'label': 'Created after', 'value': '' },
      'dateCreatedTo':         { 'label': 'Created before', 'value': '' },
      'dateLastModifiedFrom':  { 'label': 'Last modified after', 'value': '' },
      'dateLastModifiedTo':    { 'label': 'Last modified before', 'value': '' },
    },
  }),

  // ACTIONS
  actions: {
    updateField({ path, value }) {
      const segments = path.split('.');
      let target = this;
      for (let i = 0; i < segments.length - 1; i++) {
        if (!(segments[i] in target)) {
          target[segments[i]] = {}; // create intermediate object if it does not exist
        }
        target = target[segments[i]];
      }
      target[segments[segments.length - 1]] = value;
    },
  },

  // GETTERS
  getters: {
    getSearchPills,
    getSearchQueryString,
    getSearchQueryStringWithoutStatus,
  },

});